const BASE_CLASS =
  "inline-flex items-center justify-center rounded-lg font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50";

const WITH_LABEL_CLASS = "gap-1.5 px-3 py-1.5 text-sm";
const ICON_ONLY_CLASS = "h-7 w-7 shrink-0";
const ICON_ONLY_SIZE_CLASS = "text-sm";

const VARIANT_CLASSES = {
  view: `${BASE_CLASS} text-primary hover:bg-primary/5`,
  edit: `${BASE_CLASS} text-violet-600 hover:bg-violet-50`,
  delete: `${BASE_CLASS} text-red-600 hover:bg-red-50`,
  settings: `${BASE_CLASS} text-slate-600 hover:bg-slate-50`,
  block: `${BASE_CLASS} text-red-600 hover:bg-red-50`,
  unblock: `${BASE_CLASS} text-green-600 hover:bg-green-50`,
};

const ICONS = {
  view: "fi fi-rr-eye",
  edit: "fi fi-rr-pencil",
  delete: "fi fi-rr-trash",
  settings: "fi fi-rr-settings",
  block: "fi fi-rr-ban",
  unblock: "fi fi-rr-check",
};

const DEFAULT_LABELS = {
  view: "View Details",
  edit: "Edit",
  delete: "Delete",
  settings: "Settings",
  block: "Block",
  unblock: "Unblock",
};

export function TableActionButton({
  variant = "view",
  onClick,
  label,
  showLabel = true,
  className = "",
  disabled = false,
  type = "button",
  ariaLabel,
  as: Component = "button",
  ...props
}) {
  const resolvedLabel = label ?? DEFAULT_LABELS[variant] ?? "Action";
  const iconClass = ICONS[variant] ?? ICONS.view;
  const isIconOnly = !showLabel;
  const sizeClass = isIconOnly ? ICON_ONLY_CLASS : WITH_LABEL_CLASS;
  const iconSizeClass = isIconOnly ? ICON_ONLY_SIZE_CLASS : "text-sm";

  return (
    <Component
      type={Component === "button" ? type : undefined}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || resolvedLabel}
      className={`${VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.view} ${sizeClass} ${className}`}
      {...props}
    >
      <i className={`${iconClass} ${iconSizeClass}`} />
      {showLabel ? resolvedLabel : null}
    </Component>
  );
}

export function ViewDetailsButton(props) {
  return <TableActionButton variant="view" {...props} />;
}

export function EditActionButton(props) {
  return <TableActionButton variant="edit" {...props} />;
}

export function DeleteActionButton(props) {
  return <TableActionButton variant="delete" {...props} />;
}

export function SettingsActionButton(props) {
  return <TableActionButton variant="settings" {...props} />;
}

export function DragHandleButton({ className = "", isDragging = false, ...props }) {
  return (
    <button
      type="button"
      title="Drag to reorder"
      className={`${BASE_CLASS} ${ICON_ONLY_CLASS} cursor-move text-gray-400 hover:bg-gray-100 hover:text-gray-600 ${
        isDragging ? "bg-gray-100 text-gray-600" : ""
      } ${className}`}
      {...props}
    >
      <i className={`fi fi-rr-grip-dots ${ICON_ONLY_SIZE_CLASS}`} />
    </button>
  );
}

export function TableActionsCell({ children, className = "" }) {
  return (
    <td
      className={`px-4 py-1.5 whitespace-nowrap text-right text-sm font-medium sm:px-5 ${className}`}
    >
      <div className="inline-flex flex-wrap items-center justify-end gap-1">
        {children}
      </div>
    </td>
  );
}
